import React from 'react';
import { Box, Container, Grid, Section, Text } from '@radix-ui/themes';
import { useSelector } from 'react-redux';
import { selectDevice } from 'store/slices/common';

import Visual from 'components/common/visual';
import Breadcrumbs from 'components/common/breadcrumbs';
import PageTitle from 'components/layout/pageTitle';

import './style.scss';

export default function PromotionSystem() {
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  return (
    <>
      <Visual category="introduction" title="소개" />
      <Breadcrumbs category="introduction" />
      <Section p="0" pb={isMobile ? 'var(--space-18)' : 'var(--space-35)'} className="promotion-system-wrap">
        <Container size={isMobile ? '1' : '4'}>
          <PageTitle icon="school" title="사업 추진체계" />

          <Box mb={!isMobile && 'var(--space-20)'} className="system-box">
            <Text as="p" mb={isMobile ? 'var(--space-2)' : 'var(--space-6)'} className={isMobile ? 'sub-title' : 'title4'}>
              사업 추진체계
            </Text>
            <Text as="p" mb={isMobile ? 'var(--space-5)' : 'var(--space-10)'} className={isMobile ? 'body1' : 'title5 font-light'}>
              정보소외지역 SW교육지원강화사업의 정책 및 기본방향 수립(과학기술정보통신부), 전담기관(정보통신산업진흥원은 총괄 운영),
              교육거점(SW미래채움센터)으로 구성됨
            </Text>
            <img
              src={require(`assets/images/pages/intro/intro-map02${isMobile ? '-mo' : ''}.png`)}
              alt="사업 추진체계 조직도"
              aria-hidden="true"
            />
            <ul className="visually-hidden">
              <li>
                과학기술정보통신부: 정책 및 기본방향 수립
                <ul>
                  <li>
                    정보통신산업진흥원(전담기관): 총괄 운영
                    <ul>
                      <li>
                        교육거점(SW미래채움센터, 주관기관): SW교육 인프라 운영 및 관리, 지역 초·중등학생 대상 방문SW교육 수행, 지역 인재
                        대상 SW전문강사 양성 및 채용연계
                      </li>
                    </ul>
                  </li>
                  <li>지방자치단체: 지자체 내 SW교육환경 조성을 위한 지원(예산매칭 등)</li>
                </ul>
              </li>
            </ul>
          </Box>
        </Container>
      </Section>
    </>
  );
}
